<script setup lang="ts">
const emit = defineEmits<{ onSubmitted: [] }>();
const documentId = inject("documentId") as string;
const documentStore = useSubmittedDocumentStore(documentId);
const { revision } = storeToRefs(documentStore);
const checklistStore = useAssignmentReferenceChecklist(documentId)();
const { hasContinuedToReview } = storeToRefs(checklistStore);
const isSubmitting = ref(false);

const submit = async () => {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  try {
    const didSubmit = await useSubmitEdittedRevision(documentId, revision.value);
    if (!didSubmit) return;
    checklistStore.clearProgress();
    emit("onSubmitted");
  } catch {
    useBaseToast("Your paper could not be submitted. Please try again.", "error");
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <div class="flex h-full min-h-0 flex-col">
    <template v-if="!hasContinuedToReview">
      <h2 class="border-b px-4 py-3 text-h5 font-bold">Checklist</h2>
      <DocumentStudentEditingReferenceChecklistContainer class="min-h-0 grow" />
      <div class="shrink-0 border-t p-2">
        <BaseButton @click="hasContinuedToReview = true">Continue to Review</BaseButton>
      </div>
    </template>
    <template v-else>
      <div class="flex items-center justify-between gap-2 border-b px-4 py-3">
        <h2 class="text-h5 font-bold">Review Submission</h2>
        <BaseTextButton
          :aria-disabled="isSubmitting"
          @click="!isSubmitting && (hasContinuedToReview = false)"
        >
          Back to Checklist
        </BaseTextButton>
      </div>
      <div class="p-4">
        <p>Review your submission and submit when ready.</p>
        <BaseButton class="mt-2" :show-spinner="isSubmitting" @click="submit">
          Submit
        </BaseButton>
      </div>
    </template>
  </div>
</template>
